import {
  Chip,
  ChipIconInfo,
  ChipIconTimes,
  ChipIconWrapper,
  Flex,
  Grid,
  GridCell,
  HelpIcon,
  SELECT_VARIANT_WITH_CHECKBOX,
  SPACING_16,
  Select,
  SpacingVertical,
  Switcher,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  Text,
  TooltipUtils
} from 'mailup-web-components'
import { modalFilterDetailState } from 'Pages/Task/recoil/state/modals'
import { filtersState, taskConditionsState } from 'Pages/Task/recoil/state/task'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import ExcludeGroups from './ExcludeGroups'
import IncludeGroups from './IncludeGroups'

const BoxSelectRecipientsGroupsAndFilters = () => {
  const intl = useIntl()
  const [
    {
      IncludeGroups: groups,
      ExcludeGroups: eGroups,
      Filters,
      FilterConditionsRules
    },
    setTaskConditionsState
  ] = useRecoilState(taskConditionsState)
  const setModalFilterDett = useSetRecoilState(modalFilterDetailState)
  const filters = useRecoilValue(filtersState)

  const onchangeIncludeGroups = (value) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      IncludeGroups: value,
      ExcludeGroups: prev.ExcludeGroups.filter((e) => !value.includes(e)),
      isDirty: true
    }))
  }

  const onchangeExcludeGroups = (value) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      ExcludeGroups: value,
      IncludeGroups: prev.IncludeGroups.filter((e) => !value.includes(e)),
      isDirty: true
    }))
  }

  const handleFiltersChange = (value) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      Filters: value,
      isDirty: true
    }))
  }

  const onChangeFilterConditionsRules = (value) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      FilterConditionsRules: value,
      isDirty: true
    }))
  }

  const switcherOptions = [
    {
      label: intl.formatMessage({
        id: 'Load.SearchRecipients.filterAll'
      }),
      value: 'AND',
      htmlAttrs: {
        'data-tip': intl.formatMessage({
          id: 'Load.SearchRecipients.filterAllTooltip'
        })
      }
    },
    {
      label: intl.formatMessage({
        id: 'Load.SearchRecipients.filterOne'
      }),
      value: 'OR',
      htmlAttrs: {
        'data-tip': intl.formatMessage({
          id: 'Load.SearchRecipients.filterOneTooltip'
        })
      }
    }
  ]

  useEffect(() => {
    TooltipUtils.rebuild()
  }, [Filters])

  const openModalFilterDett = (props, id) => {
    setModalFilterDett({ show: true, ...props, id })
  }

  // eslint-disable-next-line react/prop-types
  const SelectedItemComponent = ({ label, value, onClick, ...props }) => {
    return (
      <Chip label={label} value={value}>
        <ChipIconWrapper
          onClick={(e) => openModalFilterDett(props, value)}
          data-mu-test='abtestwizard-sending-w__additional-group__show'
        >
          <ChipIconInfo />
        </ChipIconWrapper>
        <ChipIconWrapper
          onClick={(e) => onClick(value, e)}
          data-mu-test='abtestwizard-sending-w__additional-group__remove'
        >
          <ChipIconTimes />
        </ChipIconWrapper>
      </Chip>
    )
  }

  return (
    <>
      <Text variant={TEXT_VARIANT_BOLD}>
        {intl.formatMessage({ id: 'Load.Task.ConditionsGroupTitle' })}
      </Text>
      <SpacingVertical variant={SPACING_16} />
      <Grid cols={12}>
        <GridCell span={4}>
          <Flex margin='8px 0 0 0'>
            {intl.formatMessage({
              id: 'Load.Task.ConditionsGroupAndFilterLabelInclude'
            })}
          </Flex>
        </GridCell>
        <GridCell span={8}>
          <IncludeGroups
            handleSelectChange={onchangeIncludeGroups}
            listOptions={groups}
          />
        </GridCell>
        <GridCell span={4}>
          <Flex margin='8px 0 0 0'>
            {intl.formatMessage({
              id: 'Load.Task.ConditionsGroupAndFilterLabelExclude'
            })}
          </Flex>
        </GridCell>
        <GridCell span={8}>
          <ExcludeGroups
            handleSelectChange={onchangeExcludeGroups}
            listOptions={eGroups}
          />
        </GridCell>
        <GridCell span={4}>
          <Flex margin='8px 0 0 0'>
            {intl.formatMessage({
              id: 'Load.Task.ConditionsGroupAndFilterLabelApply'
            })}
          </Flex>
        </GridCell>

        <GridCell span={8}>
          <Grid cols={12}>
            <GridCell span={12}>
              <Select
                multiple
                searchable
                variant={SELECT_VARIANT_WITH_CHECKBOX}
                loading={false}
                placeholder={intl.formatMessage({
                  id: 'Load.Task.ConditionsGroupAndFilterFilterPlaceholder'
                })}
                options={filters.options}
                optionGroups={filters.optionGroups}
                value={Filters}
                onChange={handleFiltersChange}
                SelectedItemComponent={SelectedItemComponent}
                selectedFilters={Filters}
                data-mu-test='select-filters'
              />
            </GridCell>
            {Filters.length > 1 && (
              <GridCell span={12}>
                <Flex height='24px' alignItems='baseline'>
                  <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                    {intl.formatMessage({
                      id: 'Load.Task.ConditionsRecipientsFirstTitle'
                    })}{' '}
                  </Text>
                  <Switcher
                    options={switcherOptions}
                    value={FilterConditionsRules}
                    data-mu-test='Switcher-ApplyConditionsRule'
                    onChange={onChangeFilterConditionsRules}
                  />
                  <Text variant={TEXT_VARIANT_LIGHT} htmlElement='span'>
                    {' '}
                    {intl.formatMessage({
                      id: 'Load.TriggersDetail.IncludeFilters2'
                    })}{' '}
                  </Text>
                  <HelpIcon
                    text={intl.formatMessage(
                      { id: 'Load.TriggersDetail.TooltipIncludeFilters' },
                      {
                        linebreak: <br />
                      }
                    )}
                  />
                </Flex>
              </GridCell>
            )}
          </Grid>
        </GridCell>
      </Grid>
    </>
  )
}

export default BoxSelectRecipientsGroupsAndFilters
